import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import StoryListItem from 'app/domains/routes/Stories/StoriesList/StoriesListItem'
import StoriesEmptyIcon from 'app/components/SVGS/StoriesEmptyIcon'

import './styles.scss'
const bc = 'stories-list'

class StoriesList extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    this.props.handleScroll({ currentTarget: document.body })
  }

  render() {
    const { t, storiesList, isMobileOnly } = this.props
    return (
      <div className={bc}>
        {storiesList.size === 0 ? (
          <div className={`${bc}__empty`}>
            <StoriesEmptyIcon />
            <div className={`${bc}__empty-text`}>{t('You have no stories yet')}</div>
          </div>
        ) : (
          <React.Fragment>
            {storiesList.map(item => (
              <StoryListItem activityUserStory={item.toJSON()} isMobileOnly={isMobileOnly} key={item.get('id')} />
            ))}
          </React.Fragment>
        )}
      </div>
    )
  }
}

StoriesList.propTypes = {
  storiesList: ImmutablePropTypes.list,
  handleScroll: PropTypes.func.isRequired,
  isMobileOnly: PropTypes.bool.isRequired,
}

export default withTranslation('user')(StoriesList)
